import { render, staticRenderFns } from "./GlobalMission.vue?vue&type=template&id=4402782f"
import script from "./GlobalMission.vue?vue&type=script&lang=js"
export * from "./GlobalMission.vue?vue&type=script&lang=js"
import style0 from "./GlobalMission.vue?vue&type=style&index=0&id=4402782f&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports